import { h } from "@stencil/core";
import { ChartState } from "../interfaces/chart-state";

export const GaugeChartWrapper = (props, children) => {
    return (
        <div id={props.chartId} class={`uic-gauge-chart  ${props.rootClass}`}>
            {props.state == ChartState.LOADING && (
                <div class="uic-gauge-chart__loading_indicator">
                    <uic-loader></uic-loader>
                </div>
            )}
            {props.showNoData && (
                <div class="uic-gauge-chart__no-data-indicator">
                    <div>{props.noDataText}</div>
                </div>
            )}
            {props.size && (
                <svg
                    style={{
                        visibility: props.showNoData ? "hidden" : "inherit",
                    }}
                    width="100%"
                    height={`${props.size.height}px`}
                >
                    <g
                        class="uic-gauge-chart__chart-area"
                        transform={`translate(${props.size.width / 2},${
                            props.size.height *
                            props.size.radiusMaxHeightFraction
                        })`}
                    >
                        {children}
                    </g>
                </svg>
            )}
        </div>
    );
};
